<template>
    <section class="video-section section-padding pt-100 fix" :style="bgImg" id="video">
        <div class="container" style="margin-top:40px">
            <div class="row align-items-center">
                 <div class="col-lg-12 order-1 order-lg-2">
                    <div class="bestapp-content-inner text-center">
                        <div class="section-title text-center">
                            <div class="title-icon"></div>
                            <h2 class="title text-white">WELCOME TO RHINOCAM.ORG</h2>                      
                            <p><b>Rhinocam.org is a live camera feed from the Care for Wild rhino sanctuary. Care for Wild, in partnership with Africam, have installed these cameras to give you an inside look at what it takes to rescue, rehabilitate, rewild, release and protect rhinos. By subscribing you can help these rhinos, and get subscriber exclusive content from the Care for Wild sanctuary. </b></p>
                        </div>
                    </div>
                    <div class="row">
                <div class="col-lg-6 order-1 order-lg-1">
                    <div class="video-player">
                        <figure class="embed-responsive embed-responsive-16by9">
                            <iframe :src="video2" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                        </figure>
                    </div>
                </div>
                <div class="col-lg-6 order-1 order-lg-2">
                    <div class="video-player">
                        <figure class="embed-responsive embed-responsive-16by9">
                            <iframe :src="video" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                        </figure>
                    </div>
                </div>
            </div>
            
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Video',
        data () {
            return {
                video2: "https://www.youtube.com/embed/O_YuSZ7r9oM",
                video: "https://www.youtube.com/embed/7MPm_fQJAhk",
                bgImg: {
                    backgroundImage: `url(${require('../assets/img/home-bg.jpg')})`
                }
            }
        }
    }
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/video.scss';
</style>
